export const environment = {
  production: true,
  e2e: false,
  local: false,
};
